(function () {

  'use strict';



  var REFERENCE_SWARM_MS = 3800;

  var REFERENCE_VIEWPORT_W = 1280;

  var MOBILE_BREAKPOINT = 768;



  function clamp01(v) {

    return Math.max(0, Math.min(1, v));

  }



  function easeInOutSine(t) {

    return 0.5 - Math.cos(Math.PI * t) * 0.5;

  }



  function randomInt(min, max) {

    return min + Math.floor(Math.random() * (max - min + 1));

  }



  function getScrollXY() {

    return {

      x: window.pageXOffset || document.documentElement.scrollLeft || 0,

      y: window.pageYOffset || document.documentElement.scrollTop || 0

    };

  }



  function initMojeRoj(coordinator) {

    if (!coordinator || coordinator.getAttribute('data-moje-roj-ready') === '1') return;



    var configEl = coordinator.querySelector('[data-moje-roj-config]');

    var laserStage = coordinator.querySelector('[data-moje-roj-stage="laser"]');

    var transitStage = coordinator.querySelector('[data-moje-roj-stage="transit"]');

    var s2Stage = coordinator.querySelector('[data-moje-roj-stage="s2"]');

    if (!laserStage || !transitStage || !s2Stage) return;



    var intervalMs = 30000;

    var firstSwarmDelayMs = 5000;

    var swarmDurationMs = REFERENCE_SWARM_MS;

    var zIndexLaser = 4;

    var zIndexTransit = 24;

    var zIndexS2 = 3;

    var mobileSpeedPercent = 75;

    var mobileWavePercent = 45;

    var enableMobile = true;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;



    var laserContainers = {

      spark: laserStage.querySelector('.moje-roj__sparks'),

      firefly: laserStage.querySelector('.moje-roj__fireflies'),

      beacon: laserStage.querySelector('.moje-roj__beacons')

    };

    var transitContainers = {

      spark: transitStage.querySelector('.moje-roj__sparks'),

      firefly: transitStage.querySelector('.moje-roj__fireflies'),

      beacon: transitStage.querySelector('.moje-roj__beacons')

    };

    var s2Containers = {

      spark: s2Stage.querySelector('.moje-roj__sparks'),

      firefly: s2Stage.querySelector('.moje-roj__fireflies'),

      beacon: s2Stage.querySelector('.moje-roj__beacons')

    };



    if (

      !laserContainers.spark || !laserContainers.firefly || !laserContainers.beacon ||

      !transitContainers.spark || !transitContainers.firefly || !transitContainers.beacon ||

      !s2Containers.spark || !s2Containers.firefly || !s2Containers.beacon

    ) {

      return;

    }



    var layerContainers = {

      laser: laserContainers,

      transit: transitContainers,

      s2: s2Containers

    };



    var particles = [];

    var particleRaf = null;

    var spawnChunkRaf = null;

    var particleStart = 0;

    var lastTransitHeightSyncTs = 0;

    var swarmSafetyTimer = null;

    var zoneTimer = null;

    var cooldownVisibleMs = 0;

    var hasTriggeredFirstSwarm = false;

    var laserIntroFinished = false;

    var laserVisible = false;

    var swarmActive = false;

    var bound = false;

    var zoneScrollTicking = false;

    var stagePlaceholders = { laser: null, transit: null, s2: null };



    function readConfig() {

      var config = {};

      if (configEl) {

        try {

          config = JSON.parse(configEl.textContent || '{}');

        } catch (eCfg) {

          config = {};

        }

      }

      intervalMs = Math.max(1000, Number(config.intervalMs) || 30000);

      firstSwarmDelayMs = Math.max(500, Number(config.firstSwarmDelayMs) || 5000);

      swarmDurationMs = Math.max(1800, Number(config.swarmDurationMs) || REFERENCE_SWARM_MS);

      zIndexLaser = Number(config.zIndexLaser);

      if (!isFinite(zIndexLaser)) zIndexLaser = 4;

      zIndexTransit = Number(config.zIndexTransit);

      if (!isFinite(zIndexTransit)) zIndexTransit = 24;

      zIndexS2 = Number(config.zIndexS2);

      if (!isFinite(zIndexS2)) zIndexS2 = 3;

      mobileSpeedPercent = Number(config.mobileSpeedPercent);

      if (!isFinite(mobileSpeedPercent) || mobileSpeedPercent <= 0) mobileSpeedPercent = 75;

      mobileSpeedPercent = Math.max(30, Math.min(120, mobileSpeedPercent));

      mobileWavePercent = Number(config.mobileWavePercent);

      if (!isFinite(mobileWavePercent) || mobileWavePercent <= 0) mobileWavePercent = 45;

      mobileWavePercent = Math.max(25, Math.min(100, mobileWavePercent));

      enableMobile = config.enableMobile !== false;

    }



    function isMobileViewport(vw) {

      return vw < MOBILE_BREAKPOINT;

    }



    function isRojDisabledOnMobile() {

      var vw = window.innerWidth || document.documentElement.clientWidth || 0;

      return !enableMobile && isMobileViewport(vw);

    }



    function getMobileSpeedScale(vw) {

      var widthFactor = vw / REFERENCE_VIEWPORT_W;

      widthFactor = Math.max(0.28, Math.min(1, widthFactor));

      return widthFactor * (mobileSpeedPercent / 100);

    }



    function getParticleSpeedScale(isMobile, vw) {

      return isMobile ? getMobileSpeedScale(vw) : 1;

    }



    function getVerticalMotionScale(isMobile) {

      if (isMobile) return mobileWavePercent / 100;

      /* PC: užší pás drah než historický plný rozptyl (1.0). */
      return 0.45;

    }



    function applyStageZIndex(stage, value) {

      if (!stage) return;

      stage.style.setProperty('z-index', String(value), 'important');

    }



    readConfig();



    function findLaserMainSection() {

      var wrap = document.querySelector('.laser-section-wrapper');

      if (!wrap) return null;

      /* Hero blok bez spodní mezery — laser vrstva roje jen nad videem, spacer = transit */
      return wrap.querySelector('.laser-hero-block') || wrap.querySelector('.main-section');

    }



    /* Aktivní přistávací sekvence je Moje-s2b. */
    function findS2Root() {

      return document.querySelector('.moje-s2b');

    }



    function findS2Inner() {

      return document.querySelector('.moje-s2b__inner');

    }



    /* Rezerva pod částicí: záře/ohon nesmí přetéct do Moje-s2b. */
    function getGlowSafeInset(isMobile) {

      return isMobile ? 28 : 36;

    }



    /*
     * Letová zóna = Moje-laser-video (hero), oříznutá nad začátkem Moje-s2b.
     * Spodní hrana je nejnižší povolený Y včetně záře.
     */
    function getLaserFlightBounds(scrollOverride) {

      var scroll = scrollOverride || (frameLayoutCache && frameLayoutCache.scroll) || getScrollXY();

      var hero = findLaserMainSection();

      var wrap = document.querySelector('.laser-section-wrapper');

      var laserSection = wrap ? (wrap.closest('.shopify-section') || wrap) : null;

      var boxEl = hero || laserSection;

      if (!boxEl) return null;

      var rect = boxEl.getBoundingClientRect();

      var s2 = findS2Root();

      var s2Top = s2 ? s2.getBoundingClientRect().top : Infinity;

      var vw = window.innerWidth || document.documentElement.clientWidth || 0;

      var inset = getGlowSafeInset(vw < MOBILE_BREAKPOINT);

      var top = rect.top;

      var bottom = Math.min(rect.bottom, s2Top) - inset;

      if (bottom < top + 8) bottom = top + 8;

      return {

        top: top,

        bottom: bottom,

        left: rect.left,

        right: rect.right,

        height: Math.max(1, bottom - top),

        pageTop: top + scroll.y,

        pageBottom: bottom + scroll.y,

        s2Top: s2Top

      };

    }



    function getLaserRojZIndex() {

      var wrap = document.querySelector('.laser-section-wrapper');

      if (!wrap) return zIndexLaser;

      var base = parseInt(getComputedStyle(wrap).getPropertyValue('--laser-z-base'), 10);

      if (!isFinite(base)) base = 2;

      return base + 2;

    }



    function ensureStagePlaceholder(stage, key) {

      if (!stagePlaceholders[key] && stage.parentNode) {

        stagePlaceholders[key] = document.createComment('moje-roj-' + key);

        stage.parentNode.insertBefore(stagePlaceholders[key], stage);

      }

    }



    function restoreStage(stage, key) {

      var ph = stagePlaceholders[key];

      if (ph && ph.parentNode) {

        ph.parentNode.insertBefore(stage, ph.nextSibling);

      } else if (coordinator && stage.parentNode !== coordinator) {

        coordinator.appendChild(stage);

      }

    }



    /*
     * Výška stránky podle obsahu v #MainContent — NE scrollHeight documentu.
     * Transit vrstva na body je position:absolute; kdyby brala scrollHeight,
     * započítá sama sebe → smyčka (+ ~1 obrazovka navíc pod patičkou).
     */
    function getPageContentHeight() {
      var main = document.getElementById('MainContent');
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;

      if (main) {
        var sections = main.querySelectorAll(':scope > .shopify-section');
        var last = sections.length ? sections[sections.length - 1] : null;

        if (last) {
          var rect = last.getBoundingClientRect();
          var scroll = getScrollXY();
          var bottom = Math.ceil(rect.bottom + scroll.y);
          if (bottom > 0) return Math.max(bottom, vh);
        }

        var mainH = main.offsetHeight || 0;
        if (mainH > 0) return Math.max(mainH, vh);
      }

      return Math.max(
        document.documentElement.scrollHeight || 0,
        document.body ? document.body.scrollHeight : 0,
        vh
      );
    }

    function getDocumentHeight() {
      return getPageContentHeight();
    }

    function syncTransitStageHeight() {
      if (!transitStage || transitStage.parentNode !== document.body) return;
      var h = getPageContentHeight();
      var next = h + 'px';
      if (transitStage.style.height !== next) {
        transitStage.style.height = next;
      }
    }



    function mountLaserStage() {

      var heroBlock = findLaserMainSection();

      if (!heroBlock) return false;

      ensureStagePlaceholder(laserStage, 'laser');

      /* Mezi videem a obsahem (monitor, text) — stejný stack jako CSS v Moje-laser-video. */
      var overlay = heroBlock.querySelector('.content-overlay-layer');

      if (overlay) {

        if (laserStage.parentNode !== heroBlock || laserStage.nextElementSibling !== overlay) {

          heroBlock.insertBefore(laserStage, overlay);

        }

      } else {

        var videoLayer = heroBlock.querySelector('.laser-video-layer');

        if (videoLayer) {

          if (laserStage.parentNode !== heroBlock || laserStage.previousElementSibling !== videoLayer) {

            if (videoLayer.nextSibling) {

              heroBlock.insertBefore(laserStage, videoLayer.nextSibling);

            } else {

              heroBlock.appendChild(laserStage);

            }

          }

        } else if (laserStage.parentNode !== heroBlock) {

          heroBlock.appendChild(laserStage);

        }

      }

      applyStageZIndex(laserStage, getLaserRojZIndex());

      return true;

    }



    function mountTransitStage() {

      ensureStagePlaceholder(transitStage, 'transit');

      if (transitStage.parentNode !== document.body) {

        document.body.appendChild(transitStage);

      } else if (transitStage !== document.body.lastElementChild) {

        document.body.appendChild(transitStage);

      }

      transitStage.style.width = '100%';

      transitStage.style.maxWidth = '100%';

      syncTransitStageHeight();

      applyStageZIndex(transitStage, zIndexTransit);

      return true;

    }



    function mountS2Stage() {

      var inner = findS2Inner();

      if (!inner) return false;

      var canvas = inner.querySelector('.moje-s2b__canvas');

      ensureStagePlaceholder(s2Stage, 's2');

      // Za canvasem = při stejném z-indexu nad sekvencí; CSS z-index to dál řídí.
      if (canvas) {

        if (s2Stage.parentNode !== inner || s2Stage.previousElementSibling !== canvas) {

          if (canvas.nextSibling) {

            inner.insertBefore(s2Stage, canvas.nextSibling);

          } else {

            inner.appendChild(s2Stage);

          }

        }

      } else if (s2Stage.parentNode !== inner) {

        var anchor = inner.querySelector('.moje-s2b__planet') || inner.firstChild;

        inner.insertBefore(s2Stage, anchor);

      }

      // Nad canvasem (1–2), pod UI (progress/loader 8+)
      applyStageZIndex(s2Stage, Math.max(zIndexS2, 3));

      return true;

    }



    function mountStages() {

      readConfig();

      mountLaserStage();

    }



    function unmountStages() {

      restoreStage(laserStage, 'laser');

      restoreStage(transitStage, 'transit');

      restoreStage(s2Stage, 's2');

    }



    function getZoneMetrics() {

      var flight = getLaserFlightBounds();

      if (!flight) return null;

      var wrap = document.querySelector('.laser-section-wrapper');

      var laserSection = wrap ? (wrap.closest('.shopify-section') || wrap) : null;

      var laserRect = laserSection ? laserSection.getBoundingClientRect() : null;

      return {

        zoneTop: flight.pageTop,

        zoneBottom: flight.pageBottom,

        laserSectionBottom: laserRect ? laserRect.bottom : flight.bottom

      };

    }



    function isInSwarmZone() {

      return isLaserSectionVisible();

    }



    function isLaserSectionVisible() {

      var laserWrap = document.querySelector('.laser-section-wrapper');

      if (!laserWrap) return false;

      var laserSection = laserWrap.closest('.shopify-section') || laserWrap;

      var rect = laserSection.getBoundingClientRect();

      var vh = window.innerHeight || document.documentElement.clientHeight || 800;

      var visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);

      /* Aspoň kousek sekce v obraze — 1 px u švu nestačí k běhu roje mimo záběr. */
      return visible > 48;

    }



    function getRequiredCooldownMs() {

      return hasTriggeredFirstSwarm ? intervalMs : firstSwarmDelayMs;

    }



    function detectLaserIntroFinished() {

      var overlay = document.querySelector('.intro-sequence-overlay');

      if (!overlay) return true;

      if (overlay.classList.contains('intro-sequence-overlay--consumed')) return true;

      if (overlay.getAttribute('aria-hidden') === 'true') return true;

      var overlayDisplay = window.getComputedStyle
        ? window.getComputedStyle(overlay).display
        : overlay.style.display;

      if (overlayDisplay === 'none') return true;

      return false;

    }



    function onLaserIntroFinished() {

      if (laserIntroFinished) return;

      laserIntroFinished = true;

      /* Intro často skončí, když je laser sekce už „viditelná“. Bez resetu by
         syncLaserVisibilityState nezačala odpočet (větev nowVisible && !laserVisible). */
      cooldownVisibleMs = 0;

      laserVisible = false;

      clearZoneTimer();

      syncLaserVisibilityState();

    }



    function getMainSectionPageBottom() {

      var mainSection = findLaserMainSection();

      if (!mainSection) return -1;

      var rect = mainSection.getBoundingClientRect();

      return rect.bottom + getScrollXY().y;

    }



    function getS2PageTop() {

      var s2Root = findS2Root();

      if (!s2Root) return Infinity;

      var rect = s2Root.getBoundingClientRect();

      return rect.top + getScrollXY().y;

    }



    function getLaserSectionPageBottom() {

      var laserWrap = document.querySelector('.laser-section-wrapper');

      if (!laserWrap) return -1;

      var laserSection = laserWrap.closest('.shopify-section') || laserWrap;

      var rect = laserSection.getBoundingClientRect();

      return rect.bottom + getScrollXY().y;

    }



    function containsPointStrict(viewX, viewY, rect, padX) {
      var px = padX || 0;
      return (
        viewX >= rect.left - px &&
        viewX <= rect.right + px &&
        viewY >= rect.top &&
        viewY <= rect.bottom
      );
    }



    /*
     * Výkon: cache layoutových měření platná po dobu jednoho rAF snímku.
     * Bez ní si každá částice každý snímek volala querySelector
     * + getBoundingClientRect → forced layout a trhání při průletu roje.
     */
    var frameLayoutCache = null;

    function buildFrameLayoutCache(scroll, vh) {
      var heroBlock = findLaserMainSection();
      var flight = getLaserFlightBounds(scroll);
      var cache = {
        scroll: scroll,
        innerRect: null,
        s2Rect: null,
        heroRect: heroBlock ? heroBlock.getBoundingClientRect() : null,
        zoneMetrics: getZoneMetrics(),
        cullBottom: flight ? flight.pageBottom : Infinity,
        flight: flight,
        stageOrigins: {}
      };
      return cache;
    }

    /**
     * Roj létá jen v Moje-laser-video — vždy vrstva laser (pod monitorem/textem, nad videem).
     */
    function getLayerForParticle(pageX, pageY) {
      return 'laser';
    }



    var SPAWN_Y_MIN_RATIO = 0.08;
    var SPAWN_Y_MAX_RATIO = 0.82;

    function clampSpawnY(y, vh, zoneProgress, isMobile) {
      var flight = getLaserFlightBounds();
      if (!flight) {
        var minY = vh * SPAWN_Y_MIN_RATIO;
        var maxY = vh * 0.55;
        return Math.max(minY, Math.min(maxY, y));
      }
      var minY = flight.top + flight.height * SPAWN_Y_MIN_RATIO;
      var maxY = flight.top + flight.height * SPAWN_Y_MAX_RATIO;
      if (maxY < minY + 4) {
        minY = flight.top;
        maxY = flight.bottom;
      }
      var vertScale = getVerticalMotionScale(isMobile);
      var center = (minY + maxY) * 0.5;
      minY = center + (minY - center) * vertScale;
      maxY = center + (maxY - center) * vertScale;
      return Math.max(minY, Math.min(maxY, y));
    }

    function getSpawnY(vh, laneBias, isMobile) {
      var flight = getLaserFlightBounds();
      if (!flight) {
        return vh * (SPAWN_Y_MIN_RATIO + Math.random() * (0.55 - SPAWN_Y_MIN_RATIO));
      }

      if (laneBias) {
        return clampSpawnY(laneBias, vh, 0, isMobile);
      }

      var minY = flight.top + flight.height * SPAWN_Y_MIN_RATIO;
      var maxY = flight.top + flight.height * SPAWN_Y_MAX_RATIO;
      if (maxY < minY + 4) {
        minY = flight.top;
        maxY = flight.bottom;
      }
      var vertScale = getVerticalMotionScale(isMobile);
      var center = (minY + maxY) * 0.5;
      minY = center + (minY - center) * vertScale;
      maxY = center + (maxY - center) * vertScale;
      return minY + Math.random() * Math.max(0, maxY - minY);
    }



    function getStageForLayer(layer) {

      if (layer === 'laser') return laserStage;

      if (layer === 's2') return s2Stage;

      return transitStage;

    }



    function getStagePageOrigin(stage) {

      if (!stage) return { x: 0, y: 0 };

      if (frameLayoutCache) {
        var cacheKey = stage === laserStage ? 'laser' : stage === s2Stage ? 's2' : 'transit';
        var cached = frameLayoutCache.stageOrigins[cacheKey];
        if (cached) return cached;
        var cachedRect = stage.getBoundingClientRect();
        var origin = {
          x: cachedRect.left + frameLayoutCache.scroll.x,
          y: cachedRect.top + frameLayoutCache.scroll.y
        };
        frameLayoutCache.stageOrigins[cacheKey] = origin;
        return origin;
      }

      var rect = stage.getBoundingClientRect();

      var scroll = getScrollXY();

      return { x: rect.left + scroll.x, y: rect.top + scroll.y };

    }



    function containerForParticle(p) {

      var layerSet = layerContainers[p.layer] || transitContainers;

      if (p.kind === 'firefly') return layerSet.firefly;

      if (p.kind === 'beacon') return layerSet.beacon;

      return layerSet.spark;

    }



    function assignParticleLayer(p, pageX, pageY) {

      var nextLayer = getLayerForParticle(pageX, pageY);

      if (p.layer !== nextLayer) {

        p.layer = nextLayer;

      }

      var target = containerForParticle(p);

      if (p.el.parentNode !== target) {

        target.appendChild(p.el);

      }

    }



    function clearParticleLoop() {

      if (particleRaf) {

        cancelAnimationFrame(particleRaf);

        particleRaf = null;

      }

      if (spawnChunkRaf) {

        cancelAnimationFrame(spawnChunkRaf);

        spawnChunkRaf = null;

      }

    }



    function clearSwarmDom() {

      laserContainers.spark.textContent = '';

      laserContainers.firefly.textContent = '';

      laserContainers.beacon.textContent = '';

      transitContainers.spark.textContent = '';

      transitContainers.firefly.textContent = '';

      transitContainers.beacon.textContent = '';

      s2Containers.spark.textContent = '';

      s2Containers.firefly.textContent = '';

      s2Containers.beacon.textContent = '';

      particles = [];

    }



    function setSwarmVisible(active) {

      laserStage.classList.toggle('is-active', active);

      if (transitStage) transitStage.classList.remove('is-active');

      if (s2Stage) s2Stage.classList.remove('is-active');

    }



    function finishSwarm() {

      swarmActive = false;

      setSwarmVisible(false);

      clearParticleLoop();

      clearSwarmDom();

      if (swarmSafetyTimer) {

        clearTimeout(swarmSafetyTimer);

        swarmSafetyTimer = null;

      }

    }



    function getDurationScale() {

      return REFERENCE_SWARM_MS / swarmDurationMs;

    }



    function computeSafetyTimeoutMs(vw, isMobile) {

      var durationFactor = swarmDurationMs / REFERENCE_SWARM_MS;

      var maxSpawnDelay = 1050 * durationFactor;

      var minSpeed = (isMobile ? 175 : 235) * 0.84 * getDurationScale() * getParticleSpeedScale(isMobile, vw);

      var crossMs = ((vw + 160) / Math.max(minSpeed, 35)) * 1000;

      return Math.ceil(maxSpawnDelay + crossMs + 900);

    }



    function getExitMargin(kind, isMobile) {
      /* Malý margin: dřív odstranit částici, než glow rozšíří scrollWidth (horiz. scrollbar). */
      if (kind === 'beacon') return isMobile ? 20 : 28;

      if (kind === 'firefly') return isMobile ? 14 : 20;

      return isMobile ? 8 : 12;

    }



    function createSwarmField(vw, vh, isMobile) {

      return {

        waveCycles: isMobile ? 1.1 + Math.random() * 0.75 : 1.05 + Math.random() * 0.55,

        globalPhase: Math.random() * Math.PI * 2,

        streamCount: isMobile ? 3 : 4

      };

    }



    function getStreamSpawnY(vh, streamIndex, streamCount, isMobile) {

      var centerY = getSpawnY(vh, null, isMobile);

      if (!streamCount || streamCount <= 1) return centerY;

      var spread = vh * 0.055 * getVerticalMotionScale(isMobile);

      var offset = (streamIndex - (streamCount - 1) * 0.5) * spread;

      return getSpawnY(vh, centerY + offset, isMobile);

    }



    function waveOffsetAt(p, xNorm) {

      var tau = Math.PI * 2;

      var y = p.waveAmp * Math.sin(tau * p.waveCycles * xNorm + p.wavePhase);

      y += p.waveAmp2 * Math.sin(tau * p.waveCycles2 * xNorm + p.wavePhase2);

      return y;

    }



    function createParticleMotion(vh, vw, kind, isMobile, laneBias, swarmField, streamIndex) {

      var durationScale = getDurationScale();

      var vertScale = getVerticalMotionScale(isMobile);

      var angleSpread = kind === 'beacon' ? 0.1 : kind === 'firefly' ? 0.08 : 0.14;

      angleSpread *= 0.55 + 0.45 * vertScale;

      var angle = (Math.random() - 0.5) * angleSpread;

      if (Math.random() < 0.08) {

        angle += (Math.random() - 0.5) * 0.06;

      }



      var speedBase = kind === 'beacon'

        ? (isMobile ? 165 : 220)

        : kind === 'firefly'

          ? (isMobile ? 195 : 265)

          : (isMobile ? 230 : 305);

      var speed = speedBase * (0.86 + Math.random() * 0.22) * durationScale * getParticleSpeedScale(isMobile, vw);



      var vx = Math.cos(angle) * speed;

      var vy = Math.sin(angle) * speed * 0.12 * vertScale;



      var baseY;

      if (laneBias != null && laneBias !== false && laneBias !== 0) {

        baseY = getSpawnY(vh, laneBias, isMobile);

      } else if (swarmField) {

        baseY = getStreamSpawnY(vh, streamIndex || 0, swarmField.streamCount, isMobile);

      } else {

        baseY = getSpawnY(vh, null, isMobile);

      }



      var waveAmp = kind === 'beacon'

        ? vh * (0.055 + Math.random() * 0.05)

        : kind === 'firefly'

          ? vh * (0.075 + Math.random() * 0.065)

          : vh * (0.035 + Math.random() * 0.038);

      waveAmp *= vertScale;



      var streamPhase = swarmField

        ? (streamIndex / swarmField.streamCount) * Math.PI * 2

        : 0;

      var wavePhase = (swarmField ? swarmField.globalPhase : 0) + streamPhase + (Math.random() - 0.5) * 0.85;



      var wobbleAmp = kind === 'spark'

        ? (Math.random() < 0.4 ? (1.2 + Math.random() * 2.2) * vertScale : 0)

        : ((isMobile ? 2 : 4) + Math.random() * (isMobile ? 3 : 6)) * vertScale;



      var flight = getLaserFlightBounds();

      if (flight) {

        if (baseY > flight.bottom) baseY = flight.bottom;

        if (baseY < flight.top) baseY = flight.top;

        var roomDown = flight.bottom - baseY;

        var roomUp = baseY - flight.top;

        var maxAmp = Math.max(4, Math.min(roomDown, roomUp) * 0.85);

        if (waveAmp > maxAmp) waveAmp = maxAmp;

        if (wobbleAmp > maxAmp * 0.35) wobbleAmp = maxAmp * 0.35;

      }



      return {

        x: -(18 + Math.random() * 70),

        y: baseY,

        baseY: baseY,

        vx: vx,

        vy: vy,

        waveAmp: waveAmp,

        waveAmp2: waveAmp * (0.22 + Math.random() * 0.18),

        wavePhase: wavePhase,

        wavePhase2: wavePhase + 0.65 + Math.random() * 0.55,

        waveCycles: swarmField ? swarmField.waveCycles : 1.4,

        waveCycles2: (swarmField ? swarmField.waveCycles : 1.4) * (1.65 + Math.random() * 0.45),

        crossSpan: vw * (1.02 + Math.random() * 0.12),

        wobbleAmp: wobbleAmp,

        wobbleFreq: 0.7 + Math.random() * 1.4,

        wobblePhase: Math.random() * Math.PI * 2,

        flutterAmp: kind === 'spark' ? 0 : 0.012 + Math.random() * 0.028,

        flutterFreq: 0.85 + Math.random() * 1.2

      };

    }



    function spawnSwarmParticles() {

      readConfig();

      mountStages();

      var vw = window.innerWidth || document.documentElement.clientWidth || 1280;

      var vh = window.innerHeight || document.documentElement.clientHeight || 720;

      var isMobile = vw < 768;

      var durationFactor = swarmDurationMs / REFERENCE_SWARM_MS;

      var scroll = getScrollXY();

      var sparkCount = isMobile ? randomInt(3, 8) : randomInt(5, 12);

      var fireflyCount = isMobile ? randomInt(4, 10) : randomInt(6, 14);

      var beaconCount = isMobile ? randomInt(1, 2) : randomInt(1, 3);

      var colors = [

        'rgba(255, 255, 255, 1)',

        'rgba(232, 251, 255, 1)',

        'rgba(200, 244, 255, 1)',

        'rgba(170, 235, 255, 1)',

        'rgba(140, 220, 255, 1)'

      ];



      clearParticleLoop();

      clearSwarmDom();



      var swarmField = createSwarmField(vw, vh, isMobile);



      function addParticle(kind, motion, delayScale) {

        var el = document.createElement('span');

        el.className = kind === 'beacon'

          ? 'moje-roj__beacon'

          : (kind === 'firefly' ? 'moje-roj__firefly' : 'moje-roj__spark');

        el.style.setProperty('--sz', (

          kind === 'beacon'

            ? (isMobile ? 4 + Math.random() * 2 : 5 + Math.random() * 2.4)

            : kind === 'firefly'

              ? (3.2 + Math.random() * 2.6)

              : (1.8 + Math.random() * 2.1)

        ).toFixed(2) + 'px');

        el.style.setProperty('--spark-color', colors[Math.floor(Math.random() * colors.length)]);



        var pageX0 = scroll.x + motion.x;

        var pageY0 = scroll.y + motion.y;

        var layerName = getLayerForParticle(pageX0, pageY0);

        var layerSet = layerContainers[layerName];

        var host =

          kind === 'beacon' ? layerSet.beacon :

          kind === 'firefly' ? layerSet.firefly :

          layerSet.spark;



        var particle = {

          el: el,

          kind: kind,

          layer: layerName,

          pageX0: pageX0,

          pageY0: pageY0,

          baseY: motion.baseY,

          vx: motion.vx,

          vy: motion.vy,

          waveAmp: motion.waveAmp,

          waveAmp2: motion.waveAmp2,

          wavePhase: motion.wavePhase,

          wavePhase2: motion.wavePhase2,

          waveCycles: motion.waveCycles,

          waveCycles2: motion.waveCycles2,

          crossSpan: motion.crossSpan,

          wobbleAmp: motion.wobbleAmp,

          wobbleFreq: motion.wobbleFreq,

          wobblePhase: motion.wobblePhase,

          flutterAmp: motion.flutterAmp,

          flutterFreq: motion.flutterFreq,

          delay: Math.random() * (delayScale || 950) * durationFactor,

          peakOpacity: kind === 'beacon'

            ? 0.72 + Math.random() * 0.14

            : 0.5 + Math.random() * 0.26,

          trailEl: kind !== 'spark'

        };



        host.appendChild(el);

        particles.push(particle);

      }



      var i;

      for (i = 0; i < sparkCount; i += 1) {

        addParticle('spark', createParticleMotion(vh, vw, 'spark', isMobile, 0, swarmField, i % swarmField.streamCount), 950);

      }

      for (i = 0; i < fireflyCount; i += 1) {

        addParticle('firefly', createParticleMotion(vh, vw, 'firefly', isMobile, 0, swarmField, i % swarmField.streamCount), 1050);

      }

      for (i = 0; i < beaconCount; i += 1) {

        var laneY = getStreamSpawnY(vh, i % swarmField.streamCount, swarmField.streamCount, isMobile);

        addParticle('beacon', createParticleMotion(vh, vw, 'beacon', isMobile, laneY, swarmField, i % swarmField.streamCount), 850);

      }



      particleStart = performance.now();

      particleRaf = requestAnimationFrame(tickSwarmParticles);



      if (swarmSafetyTimer) clearTimeout(swarmSafetyTimer);

      swarmSafetyTimer = setTimeout(function () {

        if (swarmActive) finishSwarm();

      }, computeSafetyTimeoutMs(vw, isMobile));

    }



    function getParticleCullBottom() {
      if (frameLayoutCache) return frameLayoutCache.cullBottom;
      var flight = getLaserFlightBounds();
      if (flight) return flight.pageBottom;
      var hero = findLaserMainSection();
      if (hero) {
        var rect = hero.getBoundingClientRect();
        return rect.bottom + getScrollXY().y - getGlowSafeInset((window.innerWidth || 0) < MOBILE_BREAKPOINT);
      }
      return Infinity;
    }

    function shouldRemoveParticle(pageX, pageY, scroll, vw, exitMargin) {
      if (pageX > scroll.x + vw + exitMargin) return true;
      if (pageX < scroll.x - exitMargin - 80) return true;

      var flight = frameLayoutCache && frameLayoutCache.flight
        ? frameLayoutCache.flight
        : getLaserFlightBounds(scroll);
      if (flight) {
        if (pageY < flight.pageTop - 24) return true;
        if (pageY > flight.pageBottom) return true;
        return false;
      }

      var metrics = frameLayoutCache ? frameLayoutCache.zoneMetrics : getZoneMetrics();
      if (metrics && pageY < metrics.zoneTop - 24) return true;
      if (pageY > getParticleCullBottom()) return true;

      return false;
    }

    function removeParticleAt(index) {

      var p = particles[index];

      if (p && p.el && p.el.parentNode) {

        p.el.remove();

      }

      particles.splice(index, 1);

    }



    function tickSwarmParticles(now) {

      particleRaf = null;



      if (!swarmActive) {

        finishSwarm();

        return;

      }



      if (typeof document.hidden !== 'undefined' && document.hidden) {

        finishSwarm();

        return;

      }



      if (!isLaserSectionVisible()) {

        finishSwarm();

        unmountStages();

        laserVisible = false;

        clearZoneTimer();

        return;

      }



      var vw = window.innerWidth || document.documentElement.clientWidth || 1280;

      var vh = window.innerHeight || document.documentElement.clientHeight || 720;

      var isMobile = vw < 768;

      var scroll = getScrollXY();

      var elapsed = now - particleStart;



      /* Výkon: výšku transit vrstvy stačí dorovnat ~4x za sekundu, ne každý snímek. */
      if (transitStage.parentNode === document.body && now - lastTransitHeightSyncTs > 250) {

        lastTransitHeightSyncTs = now;

        syncTransitStageHeight();

      }

      frameLayoutCache = buildFrameLayoutCache(scroll, vh);



      for (var i = particles.length - 1; i >= 0; i -= 1) {

        var p = particles[i];

        var local = elapsed - p.delay;

        if (local < 0) continue;



        var tSec = local * 0.001;

        var flutter = Math.sin(tSec * p.flutterFreq + p.wobblePhase) * p.flutterAmp;

        var vx = p.vx * (1 + flutter * 0.12);



        var pageX = p.pageX0 + vx * tSec;

        var travel = pageX - p.pageX0;

        var xNorm = Math.max(0, travel / Math.max(p.crossSpan || vw, 1));

        var waveY = waveOffsetAt(p, xNorm);

        var wobble = Math.sin(tSec * p.wobbleFreq + p.wobblePhase) * p.wobbleAmp * 0.65;

        var pageY = p.pageY0 + waveY + p.vy * tSec + wobble;

        var trailVy = p.vy;

        var updateTrail = p.trailEl && (i % 3) === 0;

        if (updateTrail) {

          var xNormTrail = Math.max(0, (travel + vx * 0.028) / Math.max(p.crossSpan || vw, 1));

          trailVy = (waveOffsetAt(p, xNormTrail) - waveY) / 0.028;

        }

        var exitMargin = getExitMargin(p.kind, isMobile);

        if (shouldRemoveParticle(pageX, pageY, scroll, vw, exitMargin)) {

          removeParticleAt(i);

          continue;

        }



        assignParticleLayer(p, pageX, pageY);



        var stage = getStageForLayer(p.layer);

        var origin = getStagePageOrigin(stage);

        var localX = pageX - origin.x;

        var localY = pageY - origin.y;

        var fadeIn = easeInOutSine(clamp01(local / 160));

        var opacity = p.peakOpacity * fadeIn;



        if (updateTrail) {

          p.el.style.setProperty(

            '--trail-rot',

            (Math.atan2(trailVy, vx) * 180 / Math.PI).toFixed(1) + 'deg'

          );

        }



        p.el.style.opacity = String(opacity);

        p.el.style.transform = 'translate3d(' + localX.toFixed(1) + 'px,' + localY.toFixed(1) + 'px,0)';

      }



      frameLayoutCache = null;



      if (!particles.length) {

        finishSwarm();

        return;

      }



      particleRaf = requestAnimationFrame(tickSwarmParticles);

    }



    function triggerSwarm() {

      readConfig();

      if (reduceMotion || isRojDisabledOnMobile() || swarmActive || !isInSwarmZone()) return;

      if (typeof document.hidden !== 'undefined' && document.hidden) return;



      mountStages();

      swarmActive = true;

      hasTriggeredFirstSwarm = true;

      cooldownVisibleMs = 0;

      setSwarmVisible(true);

      spawnSwarmParticles();

    }



    function clearZoneTimer() {

      if (zoneTimer) {

        clearInterval(zoneTimer);

        zoneTimer = null;

      }

    }



    function tickLaserCooldown() {

      /* Skrytá stránka: nepočítat cooldown, jinak po návratu z minimalizace
         okamžitě vystřelí roj (a interval zbytečně měří layout na pozadí). */
      if (typeof document.hidden !== 'undefined' && document.hidden) return;

      readConfig();

      if (isRojDisabledOnMobile()) return;

      if (!laserIntroFinished) {

        if (detectLaserIntroFinished()) onLaserIntroFinished();

        return;

      }

      if (!isLaserSectionVisible()) {

        return;

      }

      if (swarmActive) return;

      if (!isInSwarmZone()) return;

      cooldownVisibleMs += 1000;

      if (cooldownVisibleMs < getRequiredCooldownMs()) return;

      triggerSwarm();

    }



    function startLaserCooldownTimer() {

      clearZoneTimer();

      zoneTimer = setInterval(tickLaserCooldown, 1000);

    }



    function syncLaserVisibilityState() {

      readConfig();

      if (!laserIntroFinished && detectLaserIntroFinished()) {

        onLaserIntroFinished();

        return;

      }

      if (isRojDisabledOnMobile()) {

        laserVisible = false;

        clearZoneTimer();

        if (swarmActive) finishSwarm();

        unmountStages();

        return;

      }

      var nowLaserVisible = isLaserSectionVisible();



      if (nowLaserVisible && !laserVisible) {

        laserVisible = true;

        if (laserIntroFinished) startLaserCooldownTimer();

      } else if (!nowLaserVisible && laserVisible) {

        laserVisible = false;

        clearZoneTimer();

        if (swarmActive) finishSwarm();

        unmountStages();

      } else if (
        nowLaserVisible &&
        laserVisible &&
        laserIntroFinished &&
        !zoneTimer &&
        !swarmActive &&
        !reduceMotion
      ) {

        /* Pojistka: intro doběhlo ve chvíli, kdy už byla sekce vidět. */
        startLaserCooldownTimer();

      }



      if (!nowLaserVisible && swarmActive) {

        finishSwarm();

        unmountStages();

      }



      if (nowLaserVisible && (isInSwarmZone() || swarmActive)) {

        mountStages();

      }

    }



    function onScrollOrResize() {

      if (zoneScrollTicking) return;

      zoneScrollTicking = true;

      requestAnimationFrame(function () {

        zoneScrollTicking = false;

        syncLaserVisibilityState();

        if (swarmActive && isLaserSectionVisible()) {

          mountStages();

        }

      });

    }



    function onVisibilityChange() {

      if (document.hidden && swarmActive) finishSwarm();

    }



    function onLaserIntroFinishedEvent() {

      onLaserIntroFinished();

    }



    function cleanup() {

      clearZoneTimer();

      finishSwarm();

      unmountStages();

      if (bound) {

        window.removeEventListener('scroll', onScrollOrResize);

        window.removeEventListener('resize', onScrollOrResize);

        document.removeEventListener('visibilitychange', onVisibilityChange);

        bound = false;

      }

      document.removeEventListener('moje:laser-intro-finished', onLaserIntroFinishedEvent);

      document.removeEventListener('moje:viewport-stable', syncTransitStageHeight);

      coordinator.removeAttribute('data-moje-roj-ready');

    }



    coordinator.setAttribute('data-moje-roj-ready', '1');

    coordinator.__mojeRojCleanup = cleanup;



    mountStages();

    syncTransitStageHeight();

    requestAnimationFrame(syncTransitStageHeight);

    laserIntroFinished = detectLaserIntroFinished();

    document.addEventListener('moje:laser-intro-finished', onLaserIntroFinishedEvent);

    document.addEventListener('moje:viewport-stable', syncTransitStageHeight);



    if (!reduceMotion) {

      window.addEventListener('scroll', onScrollOrResize, { passive: true });

      window.addEventListener('resize', onScrollOrResize, { passive: true });

      document.addEventListener('visibilitychange', onVisibilityChange);

      bound = true;

      syncLaserVisibilityState();

    }

  }



  function bootRojDebugOverlay() {
    if (!window.location.hash || window.location.hash.indexOf('roj-debug') === -1) return;
    if (window.__mojeRojDebugBooted) return;
    window.__mojeRojDebugBooted = true;

    document.documentElement.classList.add('moje-roj-debug');

    var panel = document.createElement('div');
    panel.className = 'moje-roj-debug-label';
    panel.style.top = '8px';
    panel.textContent = 'Roj debug…';
    document.body.appendChild(panel);

    function ensureBand(id, color) {
      var el = document.getElementById(id);
      if (!el) {
        el = document.createElement('div');
        el.id = id;
        el.className = 'moje-roj-debug-line';
        el.style.background = color;
        el.style.opacity = '0.75';
        el.style.height = '2px';
        document.body.appendChild(el);
      }
      return el;
    }

    function ensureBandFill(id, color) {
      var el = document.getElementById(id);
      if (!el) {
        el = document.createElement('div');
        el.id = id;
        el.style.cssText = 'position:fixed;left:0;right:0;pointer-events:none;z-index:2147483001;opacity:0.35;';
        el.style.background = color;
        document.body.appendChild(el);
      }
      return el;
    }

    function syncLines() {
      var main = document.querySelector('.laser-section-wrapper .laser-hero-block')
        || document.querySelector('.laser-section-wrapper .main-section');
      var laserSec = document.querySelector('.laser-section-wrapper');
      laserSec = laserSec ? (laserSec.closest('.shopify-section') || laserSec) : null;
      var s2 = document.querySelector('.moje-s2b');
      var s2Inner = document.querySelector('.moje-s2b__inner');
      var s2Sec = s2 ? s2.closest('.shopify-section') : null;
      var transit = document.querySelector('.moje-roj--transit');
      var laserStage = document.querySelector('.moje-roj--laser');
      var s2Stage = document.querySelector('.moje-roj--s2');

      var mainY = main ? main.getBoundingClientRect().bottom : -9999;
      var s2Y = s2 ? s2.getBoundingClientRect().top : -9999;
      var s2InnerY = s2Inner ? s2Inner.getBoundingClientRect().top : s2Y;
      var laserSecY = laserSec ? laserSec.getBoundingClientRect().bottom : mainY;
      var s2SecY = s2Sec ? s2Sec.getBoundingClientRect().top : s2Y;
      var gap = Math.round(s2Y - mainY);
      var seamPad = 80;
      var edgeInset = 40;

      var mainLine = ensureBand('moje-roj-debug-main', '#ff3333');
      var s2Line = ensureBand('moje-roj-debug-s2', '#33ff66');
      mainLine.style.top = Math.round(mainY) + 'px';
      s2Line.style.top = Math.round(s2Y) + 'px';

      var laserEdge = ensureBandFill('moje-roj-debug-laser-edge', 'rgba(255,140,0,0.55)');
      laserEdge.style.top = Math.round(mainY - seamPad) + 'px';
      laserEdge.style.height = seamPad + 'px';

      var s2Edge = ensureBandFill('moje-roj-debug-s2-edge', 'rgba(255,255,0,0.45)');
      s2Edge.style.top = Math.round(s2InnerY) + 'px';
      s2Edge.style.height = edgeInset + 'px';

      var gapFill = ensureBandFill('moje-roj-debug-gap', 'rgba(255,0,80,0.4)');
      gapFill.style.top = Math.round(Math.min(mainY, s2Y)) + 'px';
      gapFill.style.height = Math.max(2, Math.abs(gap)) + 'px';
      gapFill.style.display = gap > 1 ? 'block' : 'none';

      var cx = Math.max(40, Math.min(window.innerWidth - 40, 120));
      var cy = Math.round((mainY + s2Y) * 0.5);
      var stack = document.elementsFromPoint(cx, cy).slice(0, 8).map(function (el) {
        var id = el.id ? '#' + el.id : '';
        var cls = el.className && typeof el.className === 'string'
          ? '.' + el.className.trim().split(/\s+/).slice(0, 2).join('.')
          : '';
        return el.tagName.toLowerCase() + id + cls;
      });

      function zOf(el) {
        return el ? getComputedStyle(el).zIndex : '?';
      }

      // Detekce BOM / textového uzlu před .moje-s2
      var bomGap = 0;
      if (s2 && s2Sec) {
        bomGap = Math.round(s2.getBoundingClientRect().top - s2Sec.getBoundingClientRect().top);
      }

      panel.textContent =
        'ROJ DEBUG | gap laser→s2: ' + gap + 'px | s2 offsetTop vs section: ' + bomGap + 'px ' +
        (bomGap > 2 ? '(⚠ text/BOM mezera!)' : '(ok)') +
        ' | z laser/transit/s2: ' + zOf(laserStage) + '/' + zOf(transit) + '/' + zOf(s2Stage) +
        ' | oranžový pás = spodních ' + seamPad + 'px laseru → transit | žlutý = horních ' + edgeInset + 'px S2 | ' +
        'červená čára = main-section bottom | zelená = .moje-s2 top | ' +
        's2Sec@' + Math.round(s2SecY) + ' laserSec@' + Math.round(laserSecY) +
        ' | stack@střed: ' + stack.join(' → ');
    }

    syncLines();
    window.addEventListener('scroll', syncLines, { passive: true });
    window.addEventListener('resize', syncLines, { passive: true });
  }



  function bootAllMojeRoj() {

    document.querySelectorAll('[data-moje-roj-root]').forEach(function (coordinator) {

      if (coordinator.__mojeRojCleanup) coordinator.__mojeRojCleanup();

      initMojeRoj(coordinator);

    });

  }



  if (!window.__mojeRojSectionHooked) {

    window.__mojeRojSectionHooked = true;

    document.addEventListener('shopify:section:load', function (event) {

      if (

        event.target &&

        (event.target.querySelector('[data-moje-roj-root]') ||

          event.target.querySelector('.laser-section-wrapper') ||

          event.target.querySelector('.moje-s2b'))

      ) {

        bootAllMojeRoj();

      }

    });

    document.addEventListener('shopify:section:unload', function (event) {

      var coordinator = event.target && event.target.querySelector('[data-moje-roj-root]');

      if (coordinator && coordinator.__mojeRojCleanup) coordinator.__mojeRojCleanup();

    });

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function () {
      bootAllMojeRoj();
      bootRojDebugOverlay();
    });

  } else {

    bootAllMojeRoj();
    bootRojDebugOverlay();

  }

})();

